module.exports = __webpack_public_path__ + "img/jewellery@2x.0c84b87.png";